import EmptyLayout from './EmptyLayout';
import Layout from './Layout';
import NavbarOnlyLayout from './NavbarOnlyLayout';

const LayoutConfig = [
  {
    path: '/login',
    layout: EmptyLayout,
  },
  {
    path: '/404',
    layout: EmptyLayout,
  },
  {
    path: '/500',
    layout: EmptyLayout,
  },
  {
    path: '/welcome',
    layout: EmptyLayout,
  },
  {
    path: '/admin-login',
    layout: EmptyLayout,
  },
  {
    path: '/calendar',
    layout: Layout,
  },
  {
    path: '/calendar-settings',
    layout: Layout,
  },
  {
    path: '/campaign',
    layout: Layout,
  },
  {
    path: '/loyalty-lookup',
    layout: NavbarOnlyLayout,
  },
  {
    path: '/',
    layout: Layout,
  },
];

const getLayout = (path) => {
  const configuration = LayoutConfig.find((config) =>
    path.includes(config.path)
  );
  if (configuration) return configuration.layout;
  return Layout; // Default to Layout instead of EmptyLayout
};

export default getLayout;
